export default __webpack_public_path__ + "static/media/arrow_up_from_box.ecd0f0b8.svg";